import * as React from 'react';
import { forwardRef, useCallback } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { initI18n } from '../../../../utils';
import { Aircraft } from '../../../../Icons';
initI18n('FlightStatus');
const FlightTooltip = forwardRef(({ flight }, ref) => {
    const { FlightTooltip: css } = useTheme('FlightStatus');
    const { t } = useTranslation('FlightStatus');
    // remove leading zero and render duration item
    const renderDurationItem = useCallback((duration, translation) => {
        if (flight.duration[duration] === 0) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            parseInt(flight.duration[duration].toString(10), 10),
            translation,
            "\u00A0"));
    }, [flight]);
    const renderRouteInfo = useCallback((routeType) => {
        return (React.createElement("div", { className: cn(css.routeInfo, {
                [css.start]: routeType === 'departure',
                [css.end]: routeType === 'arrival'
            }) },
            React.createElement("div", { className: css.departure }, flight[routeType].airport.city.name),
            React.createElement("div", { className: cn(css.text_light, css.ellipsis, {
                    [css.start]: routeType === 'departure',
                    [css.end]: routeType === 'arrival'
                }) }, flight[routeType].time)));
    }, [flight]);
    return (React.createElement("div", { ref: ref, className: css.container }, flight && flight.pathCompletion > 0 && flight.pathCompletion < 100 && (React.createElement("div", { className: css.content },
        React.createElement("div", { className: css.flightInfo },
            React.createElement("div", { className: css.raceNumber },
                flight.airline.iata,
                "\u2013",
                flight.flightNumber),
            React.createElement("div", { className: css.flightStatus }, t(flight.status))),
        React.createElement("div", { className: css.routes },
            renderRouteInfo('departure'),
            React.createElement("div", { className: cn(css.icon) },
                React.createElement("div", { className: css.aircraft }, Aircraft),
                React.createElement("div", { className: cn(css.text_light, css.center) },
                    renderDurationItem('days', t('translation:d')),
                    renderDurationItem('hours', t('translation:h')),
                    renderDurationItem('minutes', t('translation:m')))),
            renderRouteInfo('arrival'))))));
});
export default FlightTooltip;
